import Alert from "@mui/material/Alert";

interface DialogErrorAlertProps {
    errorText?: string;
}

export default function DialogErrorAlert(props: Readonly<DialogErrorAlertProps>) {
    const {errorText} = props;

    if (errorText === undefined) {
        return null;
    }

    return (
        <Alert severity={"error"} sx={{mt: 1}}>
            {errorText}
        </Alert>
    );
}
